import React from 'react';
import { ChevronRight, ArrowDown } from 'lucide-react';
import { practiceInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="hero-section pt-32 lg:pt-40">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Content */}
          <div className="max-w-2xl mx-auto text-center">
            <div className="gold-accent mb-8 animate-fade-in mx-auto"></div>
            
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#2d2d2d] leading-tight mb-4 animate-fade-in-up">
              Personalized Healthcare,{' '}
              <span className="italic text-[#c9a962]">Elevated</span>
            </h1>
            
            <p className="font-serif text-xl text-[#5a5a5a] italic mb-6 animate-fade-in-up">
              Our motto: "Prevention is better than cure"
            </p>
            
            <p className="text-[#5a5a5a] text-lg leading-relaxed mb-10 animate-fade-in-up delay-100">
              {practiceInfo.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up delay-200">
              <a href="#membership" className="btn-solid">
                Become a Member
                <ChevronRight size={18} />
              </a>
              <a href="#about" className="btn-primary">
                Learn More
              </a>
            </div>

            {/* Trust indicators */}
            <div className="mt-16 pt-8 border-t border-[#e8e7e2] animate-fade-in-up delay-300">
              <div className="grid grid-cols-3 gap-8">
                <div>
                  <span className="font-serif text-3xl text-[#c9a962]">300</span>
                  <p className="text-sm text-[#8a8a8a] mt-1">Maximum Patients</p>
                </div>
                <div>
                  <span className="font-serif text-3xl text-[#c9a962]">24/7</span>
                  <p className="text-sm text-[#8a8a8a] mt-1">Provider Access</p>
                </div>
                <div>
                  <span className="font-serif text-3xl text-[#c9a962]">60+</span>
                  <p className="text-sm text-[#8a8a8a] mt-1">Min Appointments</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="hidden lg:flex justify-center mt-20 animate-fade-in delay-400">
          <a href="#about" className="flex flex-col items-center gap-2 text-[#8a8a8a] hover:text-[#c9a962] transition-colors">
            <span className="text-xs tracking-widest uppercase">Discover More</span>
            <ArrowDown size={20} className="animate-bounce" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
